module.exports = __webpack_public_path__ + "static/media/screen-dashboard.ef1c39ba.png";